import { render } from "./TabToggleButton.vue?vue&type=template&id=3e018736&scoped=true"
import script from "./TabToggleButton.vue?vue&type=script&lang=js"
export * from "./TabToggleButton.vue?vue&type=script&lang=js"

import "./TabToggleButton.vue?vue&type=style&index=0&id=3e018736&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e018736"]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn});
